import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { profileSuccess } from "../reducers/authReducer";
class CallbackPage extends React.Component {
    handleSuccess = (user) => {
        this.handleRedirect(user)
    }
    handleRedirect = () => {
        this.props.history.push("/dashboard")
        localStorage.removeItem("__url");
    }
    componentDidMount(){
        this.handleRedirect()
    }
    render() {
        return (
            
            <h1 className="loader text-white app-loader" style={{textAlign:"center",}}>Loading ....</h1>
        );
    }
}
const mapStateToProps = ({ oidc }) => {
    return { oidc }
}
const mapDispatchToProps = dispatch => {
    return { updateProfile: (info) => { dispatch(profileSuccess(info)) } }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CallbackPage));